import { Modal } from "antd";
import { ExerciseStatus, getExerciseInfo } from "../service/exercise";

function doModel(content: string, toDo?: () => void) {
    Modal.warning({
        getContainer,
        title: `提示`,
        content: content,
        okText: "我知道了",
        onOk: () => toDo?.()
    });
}

function getContainer(): any {
    return document.querySelector(".PopupContainer");
}

async function onVerify(
    exerciseId: number,
    verifyStatusList: {
        verifyStatus: ExerciseStatus;
        noticeContent: string;
        toDo?: () => void;
        callback?: () => void; // 有callback属性 直接执行callback
    }[]
) {
    const { exerciseStatus } = await getExerciseInfo(exerciseId);
    const triggerList = verifyStatusList.filter(
        item => item.verifyStatus === exerciseStatus
    );

    if (triggerList.length > 0) {
        if (triggerList[0].callback) {
            triggerList[0].callback();
        } else {
            doModel(triggerList[0].noticeContent, triggerList[0]?.toDo);
        }
        return false;
    }

    return true;
}

export default function useVerifyExercise() {
    return { onVerify };
}
